import { IIndexedItem, INamedIndexedItem } from "./indexedTypes";

export const indexedComparator = <T extends IIndexedItem>(a: T, b: T) =>
    a.index - b.index;

export const namedIndexedComparator = <T extends INamedIndexedItem>(
    a: T,
    b: T,
) =>
    indexedComparator(a, b) ||
    a.name.localeCompare(b.name, undefined, { numeric: true });
